<template>
  <div style="background: white">
    <!-- dialog -->

    <van-dialog
      class="FAModal"
      :before-close="bindBefore"
      v-model="FABind"
      title="绑定谷歌验证码"
      show-cancel-button
    >
      <div style="width: 100%; display: flex; justify-content: center">
        <vue-qrcode
          :value="
            encodeURI(`otpauth://totp/${selfData.username}?secret=${secret}`)
          "
        />
      </div>
      <van-form @submit="bindFA" ref="oneCodeForm">
        <van-field label="密钥" :value="secret" readonly />
        <van-button
          v-clipboard:copy="secret"
          v-clipboard:success="onCopy"
          type="primary"
          block
          >复制</van-button
        >
        <van-field
          v-model="oneCode"
          name="验证码"
          label="验证码"
          placeholder="验证码"
          :rules="[{ required: true, message: '请填写验证码' }]"
        />
      </van-form>
    </van-dialog>
    <van-dialog
      :before-close="setDfBefore"
      v-model="setDfModal"
      title="设定自动接单"
      show-cancel-button
    >
      <van-form>
        <van-field
          v-model="self.self_df_min"
          name="最低"
          label="最低"
          placeholder="最低"
          type="number"
          :rules="[{ required: true, message: '请填写最低' }]"
        />
        <van-field
          v-model="self.self_df_max"
          name="最高"
          label="最高"
          type="number"
          placeholder="最高"
          :rules="[{ required: true, message: '请填写最高' }]"
        />
      </van-form>
    </van-dialog>
    <van-dialog
      :before-close="editPasswordBefore"
      v-model="editPasswordModal"
      title="变更密码"
      show-cancel-button
    >
      <van-form>
        <van-field
          v-model="password"
          name="旧密码"
          label="旧密码"
          placeholder="旧密码"
          :rules="[{ required: true, message: '请填写旧密码' }]"
        />
        <van-field
          v-model="newPassword"
          name="密码"
          label="密码"
          placeholder="密码"
          :rules="[{ required: true, message: '请填写密码' }]"
        />
      </van-form>
    </van-dialog>
    <van-dialog
      :before-close="editWithDrawPasswordBefore"
      v-model="editWithDrawPasswordModal"
      title="变更密码"
      show-cancel-button
    >
      <van-form>
        <van-field
          v-model="password"
          name="旧密码"
          label="旧密码"
          placeholder="旧密码"
          :rules="[{ required: true, message: '请填写旧密码' }]"
        />
        <van-field
          v-model="newPassword"
          name="密码"
          label="密码"
          placeholder="密码"
          :rules="[{ required: true, message: '请填写密码' }]"
        />
      </van-form>
    </van-dialog>
    <!-- dialog -->
    <!-- top -->
    <van-sticky>
      <van-nav-bar title="个人信息">
        <!-- <template #left> <van-icon name="arrow-left" /> </template> -->
      </van-nav-bar>
    </van-sticky>
    <!-- top -->
    <div class="wrap">
      <div
        class="title"
        :style="{
          backgroundImage:
            'url(' +
            $returnColor().path +
            ($store.state.selfData.member_id ? '/selfBg.png' : '/selfBg.png') +
            ')',
        }"
      >
        <div class="head">
          <img
            src="../../assets/images/login_icon.png"
            alt=""
            class="userTitle"
          />
        </div>
        <div class="info">
          <p class="amount" style="color: red">系统版本 v2.0.0</p>
          <p class="name">{{ selfData.name }}</p>
          <p class="amount">
            余额 <span>¥ {{ selfData.balance | thousands }}</span>
          </p>
          <p class="amount">
            红利 <span>¥ {{ selfData.bonus | thousands }}</span>
          </p>
        </div>
      </div>
    </div>
    <van-cell>
      <template #title>
        <span class="custom-title"><van-icon name="user-o" />会员设定</span>
      </template>
    </van-cell>
    <van-cell is-link to="/bankCardP">
      <template #title>
        <span class="custom-title">收付款账户</span>
      </template>
    </van-cell>
    <!-- <van-cell is-link to="/bankCardC">
      <template #title>
        <span class="custom-title">提现账户</span>
      </template>
    </van-cell> -->
    <van-cell
      is-link
      @click="
        editPasswordModal = true;
        newPassword = '';
        password = '';
      "
    >
      <template #title>
        <span class="custom-title">修改密码</span>
      </template>
    </van-cell>
    <van-cell
      is-link
      @click="
        editWithDrawPasswordModal = true;
        newPassword = '';
        password = '';
      "
    >
      <template #title>
        <span class="custom-title">修改提现密码</span>
      </template>
    </van-cell>
    <van-cell is-link @click="set2FA">
      <template #title>
        <span class="custom-title">谷歌验证</span>
      </template>
    </van-cell>
    <van-cell is-link @click="$router.push('invites')">
      <template #title>
        <span class="custom-title">邀请码</span>
      </template>
    </van-cell>
    <p class="divider">我的团队</p>
    <van-cell is-link to="/myReport">
      <template #title>
        <span class="custom-title">个人{{ $returnBuySel("报表") }}</span>
      </template>
    </van-cell>
    <van-cell is-link to="/teamReport">
      <template #title>
        <span class="custom-title">团队{{ $returnBuySel("报表") }}</span>
      </template>
    </van-cell>
    <van-cell is-link to="/subList" v-if="!selfData.hide_team">
      <template #title>
        <span class="custom-title">下线列表</span>
      </template>
    </van-cell>
    <van-cell is-link to="/createAcc">
      <template #title>
        <span class="custom-title">创建下线</span>
      </template>
    </van-cell>
    <van-cell is-link @click="logout">
      <template #title>
        <span class="custom-title">登出</span>
      </template>
    </van-cell>
    <!-- <div class="wrap">
      <div class="cardWrap">
        <div class="cardBox" @click="$router.push('/myBank')">
          <van-icon name="cash-back-record" size="50" />
          <p>我的账户</p>
        </div>
        <div class="cardBox" @click="$router.push('/myTeam')">
          <van-icon name="user-circle-o" size="50" />
          <p>我的团队</p>
        </div>
        <div class="cardBox" @click="$router.push('/createAcc')">
          <van-icon name="user-circle-o" size="50" />
          <p>创建下线</p>
        </div>
        <div class="cardBox" @click="$router.push('/defaultSet')">
          <van-icon name="setting-o" size="50" />
          <p>基本设定</p>
        </div>
        <b></b>
        <b></b>
        <b></b>
        <b></b>
        <b></b>
        <b></b>
        <b></b>
      </div>
    </div> -->
    <foot />
  </div>
</template>
<script>
import { mapState } from "vuex";
import foot from "../../components/footer";
import { Toast } from "vant";

import VueQrcode from "vue-qrcode";
export default {
  components: { foot, VueQrcode },
  data() {
    return {
      editPasswordModal: false,
      editWithDrawPasswordModal: false,
      newPassword: "",
      password: "",
      show: false,
      setDfModal: false,
      self: {},
      FABind: false,
      secret: "",
      oneCode: "",
    };
  },
  computed: {
    ...mapState([
      "selfData",
      // ...
    ]),
  },
  methods: {
    bindBefore(method, done) {
      if (method == "confirm") {
        this.$refs.oneCodeForm.submit();
        done(false);
      } else {
        this.FABind = false;
        done();
        return;
      }
    },
    bindFA() {
      this.$http
        .post(`mobile/2fa`, {
          oneCode: this.oneCode,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$toast("成功");
            setTimeout(() => {
              this.$store.dispatch("getSelf");
            }, 1000);
            this.FABind = false;
          }
        });
    },
    onCopy() {
      this.$toast("复制成功");
    },
    set2FA() {
      if (this.selfData.enable_2fa == 0) {
        this.$http.get(`/mobile/2fa`).then((res) => {
          if (res.data.code == 0) {
            this.secret = res.data.data.secret;
            this.FABind = true;
          }
        });
      } else {
        this.$toast.success(`您已绑定`);
      }
    },
    logout() {
      this.$dialog
        .confirm({
          title: "登出",
          message: "是否登出",
        })
        .then(() => {
          this.$http.get(`/mobile/logout`).then((res) => {
            if (res.data.code == 0) {
              // this.$cookie.delete("token");
              localStorage.removeItem("token");
              this.$router.push("/userLogin");
              window.location.reload();
            }
          });
        });
    },
    setDfBefore(method, done) {
      if (method == "confirm") {
        this.$http
          .post(`/mobile/personalSetting `, {
            self_df_max: this.self.self_df_max,
            self_df_min: this.self.self_df_min,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.setDfModal = false;

              this.$store.commit("setSelf", res.data.data);
              // this.$store.dispatch("getSelf");
              Toast.success("成功");
            }
          });
        done(false);
      } else {
        this.editPasswordModal = false;
        done();
        return;
      }
    },
    setDf() {
      this.setDfModal = true;
      this.self = JSON.parse(JSON.stringify(this.selfData));
    },
    editPasswordBefore(method, done) {
      if (method == "confirm") {
        this.$http
          .put(`/mobile/password `, {
            new_password: this.newPassword,
            old_password: this.password,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.editPasswordModal = false;
              this.$successMeg();
            }
          });
        done(false);
      } else {
        this.editPasswordModal = false;
        done();
        return;
      }
    },
    editWithDrawPasswordBefore(method, done) {
      if (method == "confirm") {
        this.$http
          .put(`/mobile/password `, {
            new_withdraw_password: this.newPassword,
            old_withdraw_password: this.password,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.$successMeg();
              this.editWithDrawPasswordModal = false;
            }
          });
        done(false);
      } else {
        this.FABind = false;
        done();
        return;
      }
    },
  },
  created() {
    // this.$store.dispatch("getSelf");
    // this.$http.get(`/mobile/chat`);
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  padding: 0px;
  background-color: #fff;
}
.cardWrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  .cardBox {
    width: 150px;
    height: 120px;
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
  }
  b {
    width: 140px;
    height: 0;
  }
}
.wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    display: flex;
    padding: 0 30px;
    width: 100%;
    padding-top: 30px;
    // background-image: url("/selfBg.png");
    background-size: cover;
    background-repeat: no-repeat;
    padding-bottom: 20px;
    .head {
      display: flex;
      align-items: center;
      .img {
        width: 60px;
        height: 60px;
        background-color: #fff;
        border-radius: 100px;
      }
    }
    .info {
      margin-left: 15px;
      .name {
        font-size: 18px;
        font-weight: bold;
        color: white;
      }
      .amount {
        font-size: 14px;
        color: white;
        font-family: Arial;
      }
    }
  }
}
.divider {
  width: 100%;
  text-align: center;
  color: #cccccc;
  line-height: 40px;
}
</style>
